import {
    OBTENER_MODELOS,
    AGREGAR_MODELO,
    ELIMINAR_MODELO,
    ACTUALIZAR_MODELO,
    MODELO_ERROR,
    MODELO_OK,
    MODELO_ACTUAL,
    OBTENER_MODELO,
    SET_HOST
} from 'types/context';

export default (state, action) => {
    switch (action.type) {
        case OBTENER_MODELOS:
            return {
                ...state,
                modelos: action.payload
            }
        case SET_HOST:
            return {
                ...state,
                host: action.payload
            }
        case MODELO_ERROR:
            return {
                ...state,
                mensaje: action.payload
            }
        case MODELO_OK:
            return {
                ...state,
                mensaje: action.payload
            }
        case AGREGAR_MODELO:
            return {
                ...state,
                modelo:action.payload,
                modelos: [...state.modelos, action.payload],
                formulario: false,
                errorformulario: false
            }
        case MODELO_ACTUAL:
            return {
                ...state,
                modelo: state.modelos.find(modelo => modelo.id === action.payload)
            }
        case ELIMINAR_MODELO:
            return {
                ...state,
                modelos: state.modelos.filter(modelo => modelo.id !== action.payload),
                modelo: null
            }
        case ACTUALIZAR_MODELO:
            return {
                ...state,
                modelos: state.modelos.map(modelo => modelo.id === action.payload.id ? action.payload : modelo),
                modelo: action.payload
            }
        case OBTENER_MODELO:
            return {
                ...state,
                modelo: action.payload
            }
        default:
            return state;
    }
}